module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-footy-lives-here.1351bbcd.jpg";